var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneMessage = function SvgPhoneMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#10A2FC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6 24.17c.4-.4.4-1.04.03-1.42l-3.28-2.37a1 1 0 0 0-1.41.03l-1.5 1.5a.84.84 0 0 1-1.18 0l-4.15-4.17a.83.83 0 0 1 0-1.18l1.5-1.5c.4-.4.4-1.03.03-1.42l-2.36-3.28a1 1 0 0 0-1.41.03l-1.94 1.24c-1.84 1.84-.62 6.04 3.87 10.54 4.5 4.5 8.68 5.73 10.52 3.89l1.28-1.9v.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.7A16.8 16.8 0 0 0 4.07 27.11L1.7 35.3l7.67-2.7A16.8 16.8 0 1 0 18.5 1.7Z"
  }))));
};
export default SvgPhoneMessage;